import React from 'react'

const FragmentList = React.lazy(() => import('./FragmentList'))

export default FragmentList
